import React from 'react';
import './index.css';
import clsx from 'classnames';

const Empty = (props) => {
  const { desc, icon, title } = props;

  // 默认空状态配置
  const defaultTitle = '暂无数据';
  const defaultDesc = '当前页面暂无内容';

  // 默认空状态图标
  const defaultIcon = (
    <svg
      className='empty-default-icon'
      viewBox='0 0 64 64'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='8'
        y='12'
        width='48'
        height='40'
        rx='4'
        stroke='currentColor'
        strokeWidth='2'
      />
      <circle cx='24' cy='28' r='4' stroke='currentColor' strokeWidth='2' />
      <path
        d='M8 44L20 32L32 42L44 30L56 42'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );

  return (
    <div className={clsx('empty')}>
      <div className='empty-content'>
        <div className='empty-icon'>{icon || defaultIcon}</div>
        <div className='empty-title'>{title || defaultTitle}</div>
        <div className='empty-desc'>{desc || defaultDesc}</div>
      </div>
    </div>
  );
};

export default Empty;
